import React, { useState } from "react";
import { CBadge } from "@coreui/react";

const Tab = ({ text, callBack, active, count = "" }) => {
  return (
    <div onClick={callBack} className={`hsc-tab${active ? "-selected" : ""}`}>
      {text}
      <CBadge
        style={{ color: "white", backgroundColor: "#2bc2f7" }}
        shape="rounded-circle"
      >
        {count}
      </CBadge>
    </div>
  );
};

const HorizontalMediaType = ({ currentTab, setCurrentTab }) => {
  return (
    <div className="container-fluid w-100">
      <div className="d-flex w-100">
        <Tab
          text={"Videos"}
          callBack={() => {
            setCurrentTab(1);
          }}
          active={currentTab === 1}
        />
        <Tab
          text={"Audio"}
          callBack={() => {
            setCurrentTab(2);
          }}
          active={currentTab === 2}
        />
      <Tab
          text={"Article"}
          callBack={() => {
            setCurrentTab(3);
          }}
          active={currentTab === 3}
        />
        

        {/* <Tab
          text={"TikToks"}
          callBack={() => {
            setCurrentTab(4);
          }}
          active={currentTab === 4}
        /> */}
      </div>
    </div>
  );
};

export default HorizontalMediaType;
